<template>
    <div id="protocol-common-comp">
        <div class="protocol-common-comp-main animate__animated animate__fadeIn">
            <img
                class="protocol-close-icon"
                src="@/assets/login/login-close-icon.png"
                alt=""
                @click="closeProtocol"
            />
            <div class="protocol-common-content">
                <template>
                    <html style="padding: 20px; margin-top: -95px">
                        <head>
                            <meta
                                http-equiv="Content-Type"
                                content="application/xhtml+xml; charset=utf-8"
                            />
                            <title />
                            <!-- <link
                href="0e9d173f-f75c-4ba5-9f69-9c72f1fc4a6b_styles.css"
                type="text/css"
                rel="stylesheet"
              /> -->
                        </head>
                        <body
                            style="
                                pagewidth: 595.3pt;
                                pageheight: 841.9pt;
                                docgridtype: lines;
                                docgridlinepitch: 15.6pt;
                            "
                        >
                            <div class="Section0">
                                <div style="min-height: 72pt" />
                                <p
                                    class="Normal"
                                    style="
                                        text-align: center;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        微观世界用户服务协议
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        本协议更新并生效于：
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2025 年 8 月 30 日
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        原用户协议请点击：
                                    </span>
                                    <a
                                        href="https://map.hfwgsj.com/public/protocol"
                                        target="_blank"
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        《原微观世界用户服务协议》
                                    </a>
                                </p>

                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        一、重要须知
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1.1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        “微观世界产品或服务”是
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        指安徽微观信息科技有限公司（
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        以下亦称“
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ”
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）合法拥有并运营的微观世界网站及其关联产品和服务，包括但不限于微观世界网站
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        APP
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        的全部和
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        各个板块，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如房产地图、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3D
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        模型、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观全景、微观房管家
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微甄房
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        小程序
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        等
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        内容
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        《微观世界用户服务协议》（
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        以下亦称“
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        本协议
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ”
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）是我们与
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您（以下亦称“用户”）
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        订立的，就
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        使用微观世界
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        产品或服务
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        的相关事宜约定双方权利义务关系的协议。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        在使用我们的服务之前，请您仔细阅读并充分理解本协议的各项条款，特别是其中涉及免除或限制责任的条款、限制用户权利的条款、法律适用和争议解决条款等。我们已将重要内容以加粗字体标注，以便于您识别和重点阅读。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        您通过注册、登录、访问、浏览或使用微观世界产品或服务，或者以点击的方式表示同意本协议，则视为您已详细阅读并充分理解本协议的全部内容，同意作为本协议的一方当事人接受本协议的约束；如果您任何情况下不同意或不再同意本协议，请立即停止使用我们的服务
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们已经发布、后续可能发布的、不时修改的与微观世界
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        产品或
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        服务有关的其他相关协议（包括但不限于公约、规则、公告说明等）均属于本协议不可分割的组成部分，与本协议具有同等法律效力。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        对于后续发布的和修改的本协议和其他相关协议，我们会在为您提供相应产品或服务时向您提供或单独以适当的方式通知您。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        如果在修改更新生效后用户继续使用我们的产品或服务，则视为您接受本协议或其他相关协议的变动并自愿予以遵守。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观世界产品或服务主要面向房地产领域专业人士提供服务。未满
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        18
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        周岁的人不得注册账号，亦不得使用。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        如未满
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        18
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        周岁的人注册账号或使用我们的产品或服务，由此产生的相应法律后果，我们不承担任何责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        二、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        我们的产品与服务
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2.1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您使用微观世界产品或服务的途径，包括访问官方网站、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        APP
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        、使用小程序等。若您并非从上述途径获取微观世界产品或服务的，我们无法保证相应产品为官方版本，亦不能保障相应产品能够正常使用。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        如您因使用非官方版本的微观世界产品或服务而遭受损失，除法律法规另有明确规定外，我们不承担任何责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        为提升用户体验，或基于整体产品服务运营安全、合规经营的需要，我们的产品和
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        服务内容可能会根据实际需求进行调整、更新或限制。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        我们保留在不单独通知您的情况下修改、变更、中断、中止、终止产品和服务的权利。除非本条款另有明确规定，微观世界产品或服务的任何升级或更新版本，均受到本条款的规范。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如您对我们的产品或服务的变更有任何意见或建议，请拨打电话
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            background-color: #ffff00;
                                        "
                                    >
                                        400-0299-007
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        联系
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2.3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        当您通过我们指定的渠道支付费用后，我们仅许可您登录微观世界的产品或服务
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        后，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        在许可范围内，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        查阅、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        原样转播
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        微观世界的产品或服务
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        内容
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        您无权将微观世界的产品或服务内容迁移至任何
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        脱离于
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        微观世界产品或服务的环境中
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        使用
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        上述许可是非独占的、可依法或依约终止、中止和撤销的。如您未通过我们指定的渠道向我们支付费用，则您不享有上述许可。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        2.4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        除非得到我们事先明示的书面授权，即使您已注册账号并向我们支付费用，取得了上述授权，亦不得以任何未经授权的形式使用微观世界产品或服务，包括但不限于：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ）利用微观世界的产品或服务的全部或任何部分，开发、制作、运营与微观世界的产品或服务相同或类似的任何产品、服务或内容，或任何违法违规的产品、服务或内容；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ）自行、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        在他人帮助下，或
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        教唆
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        、帮助
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        他人将微观世界的产品或服务复制、上传、分发至与微观世界的产品或服务相同或类似的任何产品或服务；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ）
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        将微观世界产品使用权限
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        转授权、转租、转让、分发、赠送、共享；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ）将微观世界的产品或服务的全部或任何部分用作商标、设计标记、品牌名称、字号、企业名称、服务标记或徽标的一部分；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ）故意遮盖、篡改微观世界产品或服务上的权利标识，如我们的版权标识、商标、企业名称等
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        ）脱离微观世界产品的载体（网站、小程序、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        APP
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        等）转播、展示微观世界产品的全部或任何部分。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        三、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        用户账号
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        注册
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        、使用
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        与管理
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        用户注册：
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您需要注册一个
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        账号
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        方可使用
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观世界产品或服务
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您可以通过您本人真实在用的状态正常的合法移动电话号码或我们允许的其他方式注册账号。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您应保证注册信息的真实性、准确性和完整性，并及时更新。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如因注册信息不真实而引起的问题由用户本人承担，我们不负任何责任并有权暂停或终止账号的使用。注册后，您可以自行设置安全的登录密码。您的注册账号、设置的密码是您用以登录并使用微观世界产品或服务的凭证。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        第三方账号登录：此外，您也可以选择使用我们提供的第三方平台账号授权登录功能，通过您合法拥有的第三方平台的用户账号，注册并登录微观世界产品或服务，但第三方平台对此有限制或禁止的除外。您应保证所使用的第三方平台的用户账号已完成真实身份信息认证，并符合相关法律法规要求。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 等线;
                                            mso-fareast-font-family: 等线;
                                            mso-bidi-font-family: Arial;
                                            lang: EN-US;
                                            mso-fareast-language: ZH-CN;
                                            mso-ansi-language: AR-SA;
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        账号信息：您在注册、使用微观世界产品或服务的账号时，应提供真实、准确、合法、有效的身份证明材料及必要信息。您有权自行设置账号名称等信息。未经他人明示书面许可，您不得以他人名义开设账号，不得假冒仿冒他人姓名、名称、字号、商标、头像等作为账号信息。使用账号过程中，您不得采取任何方式误导社会公众混淆账号所有者，尤其不得混淆为社会公众普遍知悉的机构或个人，不得以任何形式损害他人人格权、财产权等合法权益。我们有权审核您提交的账号信息。当您提交的注册信息发生变更时（例如您更换了手机号），您应及时更新相应信息。如您提交的账号信息不符合法律、行政法规、政府规章、本协议约定的，或您提交的信息不准确、不真实、不合法，或者我们有理由判断上述信息存疑的，我们有权采取警示提醒、限期改正、重置账号信息、限制账号功能、暂停使用、关闭账号、禁止重新注册等法律法规规定的处置措施。您应自行承担因此产生的全部后果和损失，我们对此不承担除法律法规明确规定应由我们承担责任之外的责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 等线;
                                            mso-fareast-font-family: 等线;
                                            mso-bidi-font-family: Arial;
                                            lang: EN-US;
                                            mso-fareast-language: ZH-CN;
                                            mso-ansi-language: AR-SA;
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        账号的使用主体：您的账号仅限您本人使用。禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果我们有合理理由认为使用者并非账号注册者的，为保障账号安全，我们有权暂停或终止向该账号提供服务。您需自行承担违反上述要求导致的全部后果和损失，同时我们保留追究法律责任的权利。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        账号行为责任自负：除我们存在过错外，您应对您账号项下发生的一切活动和事件的所有行为结果（包括但不限于用户发表的任何内容以及由此产生的任何结果）负责。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        账号
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        安全
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ：我们有义务保护您的账号安全。同时
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        亦
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        有责任妥善保管您的账号信息，不得与他人共享账号或密码
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        因未妥善保管导致的损失由您自行承担。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        若您发现他人未经许可使用您的账号，或发现任何安全漏洞时，请立刻拨打电话
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            background-color: #ffff00;
                                        "
                                    >
                                        400-0299-007
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        联系
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ，并立即采取修改密码等方式保护您的账号安全。您理解，我们对您的请求采取行动需要合理时间，且我们应您请求而采取的措施可能无法避免或阻止侵害后果的形成或扩大。我们对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担除法律法规明确规定之外的责任。对于非因我们的原因导致的他人利用您的账号和密码所进行的任何行为及因此而产生的损失或损害，请您向相应责任人索赔。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        禁止恶意账号注册和使用行为，包括但不限于：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）禁止通过非法手段购买手机号、设备等进行账号注册和登录；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）禁止使用打码平台、接码平台、群控设备、外挂程序、刷屏软件等工具，对微观世界产品或服务进行干扰、破坏、修改或施加其他影响，实现账号注册及
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        /
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        或登录；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）禁止批量注册或登录账号，禁止频繁注销账号后另行注册；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）盗用他人账号；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）利用注册账号的方式，获得或骗取微观世界产品或服务的登录与访问权限，实施数据抓取、网络攻击、黑客入侵、漏洞扫描，以及其他破坏、干扰、妨碍微观世界产品
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        或服务正常运行的行为。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3.8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        核验用户身份真实性：为了更好的为您提供服务以及确保您的账号安全，您同意并授权我们可以根据您提供的手机号码、身份证号码等信息，向全国公民身份号码查询服务中心、电信运营商、金融服务机构等机构或单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        四、信息内容发布规范
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4.1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您可以使用微观世界产品或服务制作、发布视频、图片、文字等信息内容，并保证所发布信息内容符合法律法规要求。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4.2.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您不得在微观世界产品或服务上，或者利用微观世界产品或服务制作、复制、发布、传播以下违法违规内容：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）反对宪法确定的基本原则的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）损害国家荣誉和利益的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）宣扬民族仇恨、民族歧视，破坏民族团结的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）破坏国家宗教政策，宣扬邪教和封建迷信的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）侮辱或者诽谤他人，侵害他人名誉权、隐私权、肖像权、知识产权或其他合法权益的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        11
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）违反互联网广告相关法律法规的商业广告；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        12
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）法律、行政法规禁止的其他内容。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4.3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您不得在微观世界产品或服务上，或者利用微观世界产品或服务制作、复制、发布以下不良内容，亦应当主动抵制此类内容的传播：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）使用夸张标题，内容与标题严重不符的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）炒作绯闻、丑闻、劣迹等的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）不当评述自然灾害、重大事故等灾难的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）带有性暗示、性挑逗等易使人产生性联想的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）展现血腥、惊悚、残忍等致人身心不适的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）煽动人群歧视、地域歧视等的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）宣扬低俗、庸俗、媚俗内容的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）对他人进行暴力恐吓、威胁，实施网络暴力行为的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）散布污言秽语，损害社会公序良俗的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        11
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）其他含有违反法律法规、公共政策、公序良俗，或可能干扰我们正常运营，侵犯其他用户或第三方合法权益的。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4.4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您不得在微观世界产品或服务上，或者利用微观世界产品或服务，制作、复制、发布、传播含有高危险性、危害表演者自身或他人身心健康的内容：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）任何暴力和
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        /
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        或自残行为内容的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）任何威胁生命健康、利用危险器械表演，或其表演方法可能危及自身或他人人身和
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        /
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        或财产安全的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险活动的。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        五、网络与数据保护
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        为维护微观世界产品或服务的正常运行秩序及效率，您不得进行任何危害微观世界产品或服务运行安全或稳定的行为，亦不得利用微观世界产品或服务从事任何危害计算机网络安全的行为。该等行为包括但不限于：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）非法侵入网络、干扰网络正常功能、窃取网络数据
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        等
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        危害网络安全的活动；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络与数据安全活动的程序、工具；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）使用未经许可的数据或进入未经许可的服务器或账号；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）实施或企图实施探查、扫描、测试微观世界产品或服务的系统或网络的地址、端口、数据接口、弱点或漏洞，或其他破坏、威胁网络与数据安全的行为；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）企图干涉、破坏系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息数据服务的行为；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）进行反向工程、反向汇编、编译或者以其他方式尝试发现微观世界产品或服务的源代码或数据；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）伪造
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        TCP/IP
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        数据包名称或部分名称，伪造
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        HTTP
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        请求；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）使用任何打码平台、接码平台、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        IP
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        池、群控设备、外挂程序、刷屏软件或其他第三方工具，对微观世界产品或服务的正常运行进行干扰、破坏、修改；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        11
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）为大量获取微观世界产品或服务的信息、内容或数据等非正常使用目的，向微观世界产品或服务的系统、网络或服务器发送异常数据请求，攻击、挤占、浪费系统、网
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        络或服务器资源，致使或可能导致我们无法正常提供微观世界产品或服务，或其他用户无法正常使用微观世界产品或服务的行为；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        12
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）通过修改或伪造微观世界产品或服务的运行指令、数据包等非法技术手段增加、删减、变动微观世界产品或服务的功能或运行效果，以及将前述伪造、变造的微观世界产品或服务通过信息网络向公众传播或者进行运营；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        窃取商业秘密、窃取其他用户个人信息等违法犯罪活动；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）其他可能危害我们或其他主体计算机网络安全或合法权益的行为。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        未经我们书面许可，任何用户、第三方均不得自行或协助他人对微观世界产品或服务中的信息、内容或数据进行如下行为：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）利用微观世界产品或服务的信息、内容或数据，混淆自身与微观世界产品或服务的关系等不正当竞争的目的；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）擅自编辑、整理、改编微观世界产品或服务的信息、内容或数据后，在微观世界产品或服务的源页面以外的渠道或平台进行展示；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）采用技术手段或特殊识别方法，对微观世界产品或服务的信息、内容或数据进行修改、劫持、导流、遮挡、插入、弹窗，或其他导致用户无法正常使用微观世界产品或服务的行为；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）以盗链、数据抓取或爬取、模拟下载、深度链接等任何不正当方式盗取、监视、复制、传播、展示、镜像、上传、下载、使用微观世界产品或服务中的信息、内容或数据；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）以隐藏或修改微观世界产品或服务域名、权利管理信息、商标或标识等方式使用、传播微观世界产品或服务中的信息、内容或数据；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）干扰、篡改、伪造微观世界产品或服务的信息、内容或数据；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）对微观世界产品或服务及其运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及微观世界产品或服务运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品（信息或内容）；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）对保护微观世界产品或服务的任何安全措施技术进行破解、更改、反操作、破坏或其他篡改；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）其他违反法律法规、诚实信用原则、服务协议及规则获取或使用微观世界产品或服务的信息、内容或数据的行为。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如果我们有合理理由认为您的行为违反或可能违反上述约定的，或您有其他行为导致微观世界产品或服务的信息、内容或数据受到不利影响，或导致其他用户的权益受损的，我们有权进行处理，包括在不事先通知的情况下终止向您提供服务，并依法追究相关方的法律责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        六、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        知识产权
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        及相关权益
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观世界产品或服务中包含的任何信息、内容、数据或材料（包括但不限于图表、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        动画、模型、图片、音频、视频、界面、数据、程序、代码、文档）均受著作权法、商标法或其它法律法规的保护。由我们创作、创造、发明、编撰、合法取得、经授权获取和使用的上述内容，我们享有法律法规允许范围内的全部权利和权益，包括但不限于著作权、专利权、商标权、商业秘密权、数据权利等。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        对于
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        侵害我们合法权利或权益的
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        行为，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        保留追究
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        相关方
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        法律责任的权利，包括但不限于：要求停止侵权、删除相关内容、索赔损失、以及
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        通过其他
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        法律途径追究
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        相关方
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        民事、行政或刑事责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        我们根据您的要求，为您定制开发、创作的内容（包括但不限于
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        3D
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        模型、全景图片等），您同意该等内容的著作权及其他民事权利或权益归属我们所有。您在约定的期限内享有该等内容的排他许可使用权，使用方式仅限于您登录后，在微观世界产品和服务上查阅和转播
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        。您不得将该等内容在任何脱离于微观世界产品和服务的环境中使用，也不得允许他人
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        复制、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        查阅、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        传播
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        或使用该等内容。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您理解并承诺，您在使用微观世界产品或服务上传时发布的内容，均由您原创，或已获合法授权，或有合法来源。除非法律法规规定本协议另有约定，该等内容的权利归属您或原始权利人所有。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        如您对上传到微观世界产品或服务的内容不具有合法权利或没有合法来源，您在使用微观世界产品或服务时的行为（如在创作视听内容、开展直播时）可能侵害其他主体的合法权利，由此产生的法律后果由您自行承担。如引起第三方投诉、举报或以诉讼等方式维权索赔的，我们有权根据法律法规要求采取必要措施。因您的行为导致我们向任何第三方承担赔偿责任，或遭受国家机关处罚，或受到其他经济损失或商誉损失的，您应赔偿我们因此遭受的全部损失。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            text-decoration: underline;
                                        "
                                    >
                                        6.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            text-decoration: underline;
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        对于您通过微观世界产品或服务制作、上传、发布的任何内容，您同意我们具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、积累数据集合、开发互联网信息或数据产品与服务、传播、表演和展示此等内容（整体或部分），和
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        /
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        或将此等内容编入当前已知或以后开发的其他任何形式的作品、媒体、技术、数据集合、信息或数据产品中，且由我们享有法律法规允许范围内的全部权利和权益。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        6.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        为了更好地保护您的权利，您确认我们有权根据前款授权，自行或委托第三方对您上传发布且享有知识产权的内容进行维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，我们有权对维权事宜做出决策并独立实施。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        本协议未授予用户使用
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观世界产品或服务上
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        任何商标、服务标记、标识、域名和其他显著品牌特征的权利。我们如果尚未将
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观世界产品或服务上的标识
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        注册为注册商标的，用户不得擅自将其注册成为注册商标；若用户申请注册或已经将其注册为注册商标的，则用户应当配合公司或其合作的第三方向商标主管登记机关申请撤回该注册商标
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        申请或申请撤销该注册商标，或用户应当将该注册商标无偿地、完全地、不可撤销地转让给
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6.
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们履行法律法规对保护他人知识产权所明确规定的义务。在有理由确信用户存在明显侵犯任何第三方合法权利的情形，或者接收到其他第三方关于知识产权的权利主张或投诉时，我们有权不事先通知并随时对该涉嫌侵权的内容采取删除、屏蔽或断开等措施，且无需承担任何责任。若被采取删除、屏蔽或断开等措施的用户认为其行为或内容没有侵犯任何第三方的知识产权，可以向我们主张要求恢复其内容或行为，但应当向我们提供详细的情况说明和足够的证明文件。我们将根据实际情况判断是否恢复，但即使我们最终决定恢复相关的内容或行为，也仍然不对此前采取的措施承担任何责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        七、第三方产品或服务
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7.1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        为提高产品服务质量，我们在提供微观世界产品或服务时，可能会以包括但不限于外部链接、服务接口等形式指向或包含任何第三方所提供的网站、产品、服务或其他内容（如电子地图、广告等，本协议统称“第三方产品或服务”）。第三方产品或服务均由第三方公司或机构（简称为“第三方”）提供，我们对于第三方产品或服务的质量和水平均无法完全控制。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        我们对第三方服务的可用性、真实性、准确性或有效性不提供任何形式的担保或保证。第三方提供产品或服务的过程中向您做出的任何承诺、声明或行为与我们无关。您在使用第三方产品或服务时，请您注意阅读并遵守第三方要求您遵守的服务条款、许可协议、个人信息保护政策或其他类似法律文件。如您未遵守第三方条款、许可协议、隐私政策或其他类似法律文件，造成您的任何损失，我们不承担除法律法规明确规定承担责任之外任何责任
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如您在使用微观世界产品或服务时编辑、插入、上传了任何第三方产品或服务，请您自行认真检查第三方的能力、产品或服务是否可用和符合您的全部要求。您理解并同意，在遵守适用法律法规和本条款的前提下，您是否使用第三方产品或服务以及如何使用均由您自行判断和自愿选择。您理解并清楚使用第三方产品或服务所可能引发的风险和后果，包括但不限于侵害该第三方的合法权益、造成您或他人的隐私泄露、财产损失等问题。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                            text-decoration: underline;
                                        "
                                    >
                                        特别提示：您在微观世界产品或服务上使用某些第三方产品或服务，可能需要向第三方支付费用；如您不同意支付，请勿使用此类产品或服务，也不得将第三方产品或服务编辑、插入、上传至微观世界产品或服务。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        八、责任、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        担保与保证
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 等线;
                                            mso-fareast-font-family: 等线;
                                            mso-bidi-font-family: Arial;
                                            lang: EN-US;
                                            mso-fareast-language: ZH-CN;
                                            mso-ansi-language: AR-SA;
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您理解并同意，我们不就以下各项向您提供明示或默示的担保或保证：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）微观世界产品或服务将符合您的实际或特定需求、目的或利益；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）微观世界产品或服务的及时性、准确性、完整性及精确性；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）微观世界产品或服务将不受干扰、无中断、持续稳定或没有错误；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）使用微观世界产品或服务获得的任何结果或资料将是正确或可靠的；
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &nbsp;
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）使用微观世界产品或服务中的任何错误、问题、故障都将得到更正或解决；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）经微观世界产品或服务购买或获得的任何产品、服务或其它内容符合您的期望；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）微观世界产品或服务中的外部链接及其指向的内容的准确性、稳定性和完整性；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）微观世界产品或服务与其他第三方产品或服务能够兼容、共存；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）您在使用微观世界产品或服务过程中不面临任何风险；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）我们能发现微观世界产品或服务中任何侵害您或第三方合法权益的行为。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们会尽最大努力确保服务的连贯性和安全性，但
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        涉及到互联网及移动通讯等服务，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        仍
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        可能受各个环节不稳定因素的影响
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。您理解并同意，因下述情况导致服务暂停、中止、终止或造成任何损失的，我们在法律法规允许范围内免于承担责任：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）因不可抗力等因素，包括但不限于政府行为、自然灾害（如洪水、地震、台风等）、战争、罢工、骚乱、疫情等；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）因电力故障、通讯网络故障、黑客攻击、恶意程序攻击、病毒、第三方服务瑕疵等我们不能控制的因素；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）我们对微观世界产品及服务的相关系统或设备进行检修、维护、升级、保养。我们将尽最大努力在此种情况下事先通知您。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如因
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        微观世界产品或服务
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        系统发生故障而影响到服务的正常运行，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        承诺
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        尽力
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        及时处理并进行修复。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        就下列相关
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        情形，除非法律法规另有规定，我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        在此声明不承担任何法律责任
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）用户违反国家法律法规或本用户协议，对用户自身或任何第三方所造成的任何后果；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）我们依法或依约终止、中止、暂停向用户提供产品或服务，对用户造成的任何后果；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）由于您将账号告知他人，或转让、转租、分发、与他人共享账号，由此导致的任何个人信息的泄露，或其他非因我们过错导致的个人信息的泄露；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）根据法律规定、政府相关政策要求，执行、配合、协助有权机关（如司法机关、政府等）的任何行为，如提供您的个人信息和使用本产品服务的相关记录；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）您对微观世界产品或服务的误解；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）您在试用微观世界产品或服务时产生的任何后果；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）未从我们指定的渠道获得微观世界产品或服务的官方版本。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.5
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        除法律法规另有明确规定外，在任何情况下，我们均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任，该等损害包括但不限于您因使用微观世界产品或服务而遭受的利润损失。除法律法规另有明确规定外，我们对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用微观世界产品或服务期间而
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        支付给我们的费用（如有）。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.6
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        您从微观世界产品或服务获得的任何建议或信息（无论书面或口头形式）均不构成本条协议明确规定以外的任何担保或保证。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.7
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如因用户
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        违反国家法律法规或本用户协议
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        使用本产品或服务，导致我们遭受任何第三方发起的
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        纠纷、诉讼、索赔要求
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        并遭受损失的，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        用户须
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        向我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        赔偿相应损失
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        8.8
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        本协议所约定的免责和责任限制条款，不适用于因下列原因导致的责任：
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）我们的故意或重大过失行为；
                                    </span>
                                    <br />
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        （
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        ）微观世界产品或服务存在违反法律、法规禁止性规定的重大缺陷。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        九、
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        法律适用与争议解决
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        .1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        本协议的签订、履行、解释及争议的解决均适用中华人民共和国法律。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        9.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向安徽微观信息科技有限公司所在地有管辖权的人民法院提起诉讼。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                            font-weight: bold;
                                        "
                                    >
                                        十、其他
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        .1
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        如本协议的任何条款因任何原因被判定为无效或不可执行，其他条款仍应保持有效和可执行。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10.2
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        在本协议由于任何原因终止的情况下，关于知识产权、责任、赔偿、担保与保证、法律适用和争议解决的条款始终有效。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10.3
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        对于您过往的违反本协议的行为，我们仍可依据本协议向您追究责任。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        10.4
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        我们
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        未行使本协议的任何权利或规定，
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        以及本协议未列明的任何权利或权益，均
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        不构成对
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        任何
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        权利
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        或权益
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        之放弃。
                                    </span>
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 仿宋;
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        除本协议和法律法规明确规定的之外，本条款未赋予我们和您任何其他权利，也未要求我们和您承担任何其他义务。
                                    </span>
                                </p>
                                <p
                                    class="Normal"
                                    style="
                                        text-align: justify;
                                        line-height: 1.25;
                                        margin-top: 7.8pt;
                                        margin-bottom: 7.8pt;
                                        font-size: 11pt;
                                    "
                                >
                                    <span
                                        style="
                                            font-size: 11pt;
                                            font-family: 'Times New Roman';
                                            mso-fareast-font-family: 仿宋;
                                            mso-bidi-font-family: 'Times New Roman';
                                        "
                                    >
                                        &#xa0;
                                    </span>
                                </p>
                            </div>
                        </body>
                    </html>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProtocolComp',
    created() {},
    data() {
        return {}
    },
    mounted() {},
    methods: {
        closeProtocol() {
            this.$emit('closeProtocol')
        },
    },
}
</script>

<style lang="less" scoped>
@import '@/components/Login/css/protocol.less';
</style>
